import React, { Component, Suspense, lazy } from "react"
import { Router, Route, Switch, Redirect } from "react-router-dom"
import { withAuth0 } from "@auth0/auth0-react"

import history from "./history"
import Login from "./Auth/Login"
import Logout from "./Auth/Logout"
import PrivateRoute from "./Components/PrivateRoute"
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles"
import { red, blue } from "@material-ui/core/colors"
import MainAppBar from "./Components/MainAppBar"
import { HITL_USER_ROLES } from "./Config"

const Task = lazy(() => import("./Components/Task"))
const OrderNavigation = lazy(() => import("./Components/OrderNavigation"))
const TaskNavigation = lazy(() => import("./Components/TaskNavigation"))
const RetailerNavigation = lazy(() => import("./Components/RetailerNavigation"))

console.log("App version: ", window?.env?.REACT_APP_VERSION)
console.log("App build: ", window?.env?.REACT_APP_BUILD)

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
    suppressDeprecationWarnings: true,
  },
  palette: {
    primary: blue,
    secondary: {
      main: "#66bb6a",
    },
    error: red,
  },
})

class App extends Component {
  render() {
    return (
      <Router history={history}>
        <MuiThemeProvider theme={theme}>
          <div className="App">
            <MainAppBar>
              <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                  <Route exact path="/" component={Login} />

                  {/* Redirect /task to /tasks */}
                  <Redirect from="/task" to="/tasks" />

                  <PrivateRoute exact path="/tasks" component={Task} roles={HITL_USER_ROLES} />
                  <PrivateRoute exact path="/tasks/:id" component={Task} roles={HITL_USER_ROLES} />
                  <PrivateRoute
                    exact
                    path="/verify/:storeId"
                    component={OrderNavigation}
                    roles={HITL_USER_ROLES}
                  />
                  <PrivateRoute
                    exact
                    path="/verify/:storeId/:id"
                    component={TaskNavigation}
                    roles={HITL_USER_ROLES}
                  />
                  <PrivateRoute
                    exact
                    path="/retailer-verify/:storeId"
                    component={RetailerNavigation}
                    roles={HITL_USER_ROLES}
                    permission="store.retailer-verify.view"
                  />
                  <Route exact path="/operator-logout" component={Logout} />
                </Switch>
              </Suspense>
            </MainAppBar>
          </div>
        </MuiThemeProvider>
      </Router>
    )
  }
}
export default withAuth0(App)
